// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"7b7d80c6","593":"a00a45b0","921":"a00a45b0"}[chunkId] + ".chunk.css";
};